import { useContext, useState } from "react";
import UiContext from "../../../../store/ui-context";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import { format, subDays } from "date-fns";

const defaultTake = 10;
const allDataTake = 1000000;

export const useAPIGetReportProductCustomerSummary = () => {
  const uiContext = useContext(UiContext);
  const { requestGet, loading } = useAPIRequest();

  const [filterValue, setFilterValue] = useState({
    start_date: subDays(new Date(), 30),
    end_date: new Date(),
    product_id: null,
    data_product: null,
  });

  const [paging, setPaging] = useState({
    page: 1,
    take: defaultTake,
    total: 0,
    filter: "",
  });
  const [listData, setListData] = useState([]);

  //  API call section

  const reportRequestParams = {
    prefix: "product_customer_summary",
    order: "total_customer_buy",
    order_method: "DESC",
  };

  const fetchListData = async (props) => {
    const { page, take, filter } = props ?? {};

    const newFilter = filter ?? getFilter(filterValue);
    const currentPage = page ?? 1;
    const currentTake = take ?? defaultTake;

    return requestGet({
      fullUrl: `/api/report`,
      params: {
        ...reportRequestParams,
        page: currentPage,
        take: currentTake,
        filter: newFilter,
      },
      onSuccess: ({ pagination, data }) => {
        const newData = data.map((el, index) => ({
          ...el,
          no: (currentPage - 1) * currentTake + index + 1,
        }));

        setListData(newData);
        setPaging({
          ...paging,
          total: pagination?.total ?? 0,
          page: pagination?.page ?? currentPage,
          take: pagination?.take ?? currentTake,
          filter: newFilter,
        });
      },
      onError: ({ message }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // fetches the whole filtered result set in one shot, for PRINT/EXCEL/COPY
  // (which need every row, not just the page currently on screen)
  const fetchAllData = async (filter) => {
    const newFilter = filter ?? paging.filter ?? getFilter(filterValue);

    const data = await requestGet({
      fullUrl: `/api/report`,
      params: {
        ...reportRequestParams,
        page: 1,
        take: allDataTake,
        filter: newFilter,
      },
      onError: ({ message }) => uiContext.showErrorMsg("Error", message),
    });

    if (!data) return [];

    return data.map((el, index) => ({ ...el, no: index + 1 }));
  };

  // other function section

  const getFilter = (_filterValue) => {
    const filterArr = [];
    const newFilterValue = _filterValue ?? filterValue;

    filterArr.push(`start_date:=:${format(newFilterValue.start_date ?? new Date(), "yyyy-MM-dd")}`);
    filterArr.push(`end_date:=:${format(newFilterValue.end_date ?? new Date(), "yyyy-MM-dd")}`);

    if (newFilterValue.product_id) {
      if (String(newFilterValue.product_id).includes(",")) {
        filterArr.push(`product_id:in:${newFilterValue.product_id}`);
      } else {
        filterArr.push(`product_id:=:${newFilterValue.product_id}`);
      }
    }

    return filterArr.join(";");
  };

  // handle ui event section

  const handleOnClickRefresh = async () => {
    fetchListData({ page: 1, take: defaultTake });
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    return fetchListData({ page: newPage, take: newTake, filter: paging.filter });
  };

  return {
    loading,
    listData,
    fetchListData,
    fetchAllData,
    filterValue,
    setFilterValue,
    getFilter,
    handleOnClickRefresh,
    handleOnPage,
    paging,
  };
};
